/* Dialog Text */
import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { DialogResult, DialogResultType } from "../../DialogResult";

export interface EditCouponsDialogData {
  dialogTitle: string;
  isNew: boolean;
  couponCode: string;
  description: string;
  startDate?: string;
  expirationDate: string;
  oneTimeUse: boolean;
  couponType: string;
  freeTrialLength?: number;
  discountPercent?: number;
  discountAmount?: number;
  active: boolean;
}

@Component({
  selector: "edit-coupon-dialog",
  styleUrls: ["edit-coupon-dialog.component.css"],
  templateUrl: "./edit-coupon-dialog.component.html",
})
export class EditCouponsDialogComponent {
  public Result: DialogResult;

  constructor(
    public dialogRef: MatDialogRef<EditCouponsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EditCouponsDialogData
  ) {
    this.Result = new DialogResult();
    this.Result.ResultType = DialogResultType.Cancel;
    this.Result.ResultData = null;
  }

  onCancelClick(): void {
    this.dialogRef.close(this.Result);
  }

  onConfirmClick(): void {
    this.Result.ResultType = DialogResultType.Ok;
    this.Result.ResultData = this.data;
    this.dialogRef.close(this.Result);
  }
}

/* Calling Methods */
/*
  callEditCoupons(params: EditCouponsDialogData) {
    var dialogRef = this.dialog.open(EditCouponsDialogComponent, {
      width: '500px',
      data: params
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result != null && result.ResultType != null && result.ResultType == DialogResultType.Ok) {
        //Do something here!
      }
    });
  }
*/
